import React, {Component} from 'react';
import { translate, Trans } from "react-i18next";
import Form from 'react-validation/build/form';
import Input from 'react-validation/build/input';
import {required,email,isValidForm} from '../../server/validationMethods.js'
import Draft from './draft';
class FosterQualify extends Component {
    constructor(props){
        super(props);
        this.state={
            hasError:false
        }
        this.validatePage=this.validatePage.bind(this);
        this.getSelectedStudentsNames=this.getSelectedStudentsNames.bind(this)
        this.childComponentRef = React.createRef();
    }
    getSelectedStudentsNames=()=>{
        let studentNames=[]
        this.props.lunchObj.studentList.map((student)=>{
            if(student.isSelected){
                studentNames.push(student.lname+' '+student.fname)
            }
        });
       return studentNames.join(', ')
    }
    validatePage=()=>{
        if(this.props.lunchObj.isAllFoster===null){
            return false
        }else{
            if(this.props.lunchObj.isAllFoster===true){
                let someSelected=this.props.lunchObj.studentList.some(function (e) {
                    return e.liveUnderFosterCare;
                });
                if(!someSelected){
                    return false;
                }else{
                    return true
                }
            }else{
                return true
            }
        }
    }
render(){
    return(
        <div>
            <div className="row">
                <div className="col-xs-12 block">
                    <div className="schoolInfo">
                        <p><strong><Trans>No problem! There are other ways to qualify</Trans>.</strong></p>
                    </div>
                </div>
            </div>
            
            <div className="row">
                <div className="col-md-12">
                    <p>
                    { (!this.validatePage()) && this.state.hasError? <span className="text-danger"> <Trans>Please enter all required information above</Trans>.</span>:null
                    }</p>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <p><Trans>Do</Trans> <strong>{this.getSelectedStudentsNames()}</strong>  <Trans>live with you under a formal (court-ordered) foster care arrangement?</Trans>
                    </p>
                </div>
                <div className="col-md-12">
                    <div className="styled-input-container styled-input--rounded">
                        <ul>
                            <li>
                                <div className="styled-input-single" style={{padding: '0px 0px 0px 33px'}}>
                                        <input id={'isAllFosterYes'} name="isAllFoster" checked={this.props.lunchObj.isAllFoster===true}
                                         type='radio' onChange={(e)=>{
                                            this.props.onAllFosterSelectChange(e.target.name,e.target.checked?true:false); 
                                            this.setState({hasError:false}) 
                                            this.childComponentRef.current.formatDraftReqObj();                                       
                                        }} /> 
                                        <label htmlFor={'isAllFosterYes'}>
                                        <Trans>{'Yes'}</Trans></label>
                                </div>
                            </li>
                            <li>
                                <div className="styled-input-single" style={{padding: '0px 0px 0px 33px'}}>
                                    <input id={'isAllFosterNo'} name="isAllFoster" checked={this.props.lunchObj.isAllFoster===false}
                                         type='radio' onChange={(e)=>{
                                            this.props.onAllFosterSelectChange(e.target.name,e.target.checked?false:true);
                                            this.setState({hasError:false})  
                                            this.childComponentRef.current.formatDraftReqObj();                                          
                                        }} /> 
                                    <label htmlFor={'isAllFosterNo'}>
                                    <Trans>{'No'}</Trans></label>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            {
                this.props.lunchObj.isAllFoster===true?
                <div className="row">
                <div className="col-xs-12">
                <p><strong><Trans>Which students?</Trans></strong></p>
                </div>
                <div className="col-xs-12">
                <div className="styled-input-container styled-input--square">
                    <ul>
                    {
                        this.props.lunchObj.studentList.map((item,k)=>{
                            if(item.isSelected){
                                return <li style={{padding:'7px 7px 0px 10px'}}>
                                    <div className="styled-input-single" style={{padding:'1px 0px 5px 40px'}}>
                                        <input id={'stud'+k} checked={item.liveUnderFosterCare} data-idx={k} type='checkbox' onChange={(e)=>{
                                            let _idx=e.target.getAttribute('data-idx');
                                            this.props.onStudentFasterSelectChange(_idx,e.target.checked?true:false); 
                                            this.childComponentRef.current.formatDraftReqObj();                                                                                      
                                        }} /> 
                                        <label htmlFor={'stud'+k}>
                                        {item.lname+', '+item.fname}</label>
                                     </div>
                                </li>
                            }                        
                        })
                    }   
                    </ul>
                    </div>
                    </div>
                </div>:null

            }
            <div className="row">
                <div className="col-xs-12">
                        <button className="btn btn-next bg-color-4 btn-xs pull-left" onClick={(e)=>{
                        this.props.jumpToStep(4)
                    }}>
                        <Trans>Previous</Trans>
                    </button>
                    <button className="btn btn-prev btn-xs bg-color-2 pull-right" onClick={(e)=>{                       
                            if(!this.validatePage()){
                                this.setState({hasError:true})
                            }else{
                                let selectedStudents=this.props.lunchObj.studentList.filter((student)=>{
                                    return student.isSelected
                                })
                                let everyOneSelected=selectedStudents.every((stu)=>
                                {return stu.liveUnderFosterCare});
                                if(everyOneSelected){
                                    this.props.jumpToStep(12);
                                }else{
                                    this.props.jumpToStep(6);
                                }
                                
                                return true;
                            }
                    }}>
                        <Trans>Continue</Trans>
                    </button>
                        <Draft lunchObj={this.props.lunchObj} schoolInfo={this.props.schoolInfo} ref={this.childComponentRef} />
                </div>
            </div>
        </div>
    )
}
}
export default FosterQualify;


// WEBPACK FOOTER //
// ./src/components/FreeReducedProgram/fosterQualify.jsx